import {User} from "../model/User";
import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY_LOCAL_STORAGE || 'default_secret_key';
const USER_REF = 'a4519232b014b24cd3949074850f4da84899267321a52f244bbbce5a65987f5f';
const BUSINESS_REF = '12244CCD59BC688384A435B869CD6';

// // Função para criptografar os dados do usuário
const encryptrData = (data: any) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
};


const decryptUserData = (encryptedData: string): User | null => {
    try {
        const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
        const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedData);
    } catch (error) {
        console.error("Failed to decrypt user data", error);
        return null;
    }
};

// Função para salvar o usuário cryptographic no localStorage
const saveToLocalStorage = (key: string, data: any | null) => {
    if(!key){
        return;
    }
    if (data) {
        const encrypted = encryptrData(data);
        localStorage.setItem(key, encrypted);
    } else {
        localStorage.removeItem(key);
    }
};
const getFromLocalStorage = (key: string): any | null => {
    const encrypted = localStorage.getItem(key);
    return encrypted ? decryptUserData(encrypted) : null;
};

export const saveBusinessToLocalStorage = (data: any | null) => {
    saveToLocalStorage(BUSINESS_REF, data);
}
export const getBusinessFromLocalStorage = (): any => {
    return getFromLocalStorage(BUSINESS_REF);
}
export const logoutBusinessLocalStorage = () => {
    localStorage.removeItem(BUSINESS_REF);
};


const logoutLocalStorage = (key: string) => {
    localStorage.removeItem(key);
};

